import {Model} from "mobx-rest/lib";
import { NestedModel } from "../../nestedmodel";

export class UxConfig extends Model {
    constructor(props, attributes) {
        super(Object.assign({}, attributes));
        this._cpeIds = {};
    }

    urlRoot() {
        return '/deviceFeatureSets/uxConfig';
    }

    url() {
        return this.urlRoot();
    }

    cpeId(value) {
        if (!this._cpeIds[value]) {
            this._cpeIds[value] = new NestedModel({value: value, parent: this});
        }
        return this._cpeIds[value];
    }
}